module.exports = __webpack_public_path__ + "media/step3_animation.0c5ff9ae.mp4";